import {intlLocale} from "../i18n.js"

// Committee room credits badge: the Project's credits, counted up from the
// previous total whenever the server sends a new one (every rollup after a
// turn or a consult), with a short highlight so the increment is noticed.
// The server owns the number (`data-credits`); this hook owns the text.
const format = (n) => Math.round(n).toLocaleString(intlLocale())

export default {
  mounted() {
    this.value = this.read()
    this.render(this.value)
  },

  updated() {
    const next = this.read()
    if (next === this.value) return
    this.animate(this.value, next)
    this.value = next
  },

  destroyed() {
    cancelAnimationFrame(this.raf)
    clearTimeout(this.highlight)
  },

  read() {
    const n = Number(this.el.dataset.credits || 0)
    return Number.isFinite(n) ? n : 0
  },

  render(n) {
    const target = this.el.querySelector('[data-role="value"]')
    if (target) target.textContent = format(n)
  },

  animate(from, to) {
    cancelAnimationFrame(this.raf)
    const start = performance.now()
    const duration = 900
    const step = (now) => {
      const p = Math.min(1, (now - start) / duration)
      const eased = 1 - Math.pow(1 - p, 3)
      this.render(from + (to - from) * eased)
      if (p < 1) this.raf = requestAnimationFrame(step)
    }
    this.raf = requestAnimationFrame(step)

    this.el.style.opacity = "1"
    clearTimeout(this.highlight)
    this.highlight = setTimeout(() => (this.el.style.opacity = ""), 1600)
  },
}
